module.exports = {
  requestPool : [],
  addItem(cb){
    this.requestPool.push(cb)
  },
  dispatchToken(token){
    this.requestPool.map(cb => cb(token))
  },
}